<template>
  <div class="d-flex justify-content-center">
    <Transition
      name="fade"
      mode="out-in"
      appear>
      <div
        v-if="$slots.actionButton"
        class="d-flex flex-column align-items-center gap-md w-100">
        <div class="d-flex gap-md w-100">
          <slot name="actionButton"/>
          <BaseButton
            :text="buttonText"
            class="w-100"
            @click="emit('next-step')"/>
        </div>
        <BaseButton
          v-if="showBackButton"
          text="Back"
          variant="secondary"
          :class="isMobile ? 'w-100' : 'w-50'"
          @click="emit('previous-step')"/>
        <BaseButton
          v-else-if="isFirstStep"
          text="Skip For Now"
          variant="text-link"
          @click="emit('close')"/>
      </div>
      <div
        v-else
        class="d-flex gap-md"
        :class="[
          isMobile || isFirstStep ? 'flex-column' : 'flex-row-reverse',
          { 'w-100': isMobile || isFirstStep }
        ]"
        :style="isMobile || isFirstStep ? {} : { width: '275px' }">
        <BaseButton
          :text="buttonText"
          class="w-100"
          @click="emit('next-step')"/>
        <BaseButton
          v-if="showBackButton"
          text="Back"
          variant="secondary"
          class="w-100"
          @click="emit('previous-step')"/>
        <BaseButton
          v-else-if="isFirstStep"
          text="Skip For Now"
          variant="text-link"
          class="w-100"
          @click="emit('close')"/>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import useScreenSize from '@shared/composables/screenSize.js'

defineProps({
  buttonText: {
    type: String,
    default: 'Next Step'
  },
  showBackButton: {
    type: Boolean,
    default: false
  },
  isFirstStep: {
    type: Boolean,
    default: false
  }
})

const { isMobile } = useScreenSize()

const emit = defineEmits(['next-step', 'previous-step', 'close'])
</script>
